import { useState, useEffect } from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download'; 
import '../../App.css';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import '../resources/resourceWrapp.css';
import { END_URL, IMG_URL } from '../../config';
import OrgangeRoll from '../../images/orange-roll.gif';
import UserFooter from '../footer/UserFooter.jsx';

function ResourceWrapp() {
  const [expanded1, setExpanded] = useState(false);
  const [pdfs, setPdfs] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
   const [dynamicContent, setDynamicContent] = useState(null);

   const categories = Array.from(
  new Set(pdfs.map((pdf) => pdf.category).filter(Boolean))
);

const [selectedCategory, setSelectedCategory] = useState('0');
const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchPdfs = async () => {
      try {
        const response = await axios.get(`${END_URL}pdf`);
        if (response.data.status) {
          setPdfs(response.data.data);
        } else {
          setError('Failed to fetch PDFs');
        }
      } catch (err) {
        setError('Error fetching PDFs');
      } finally {
        setLoading(true);
      }
    };

    fetchPdfs();
  }, []);

 
  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const formatted = date.toLocaleDateString('en-US', options);
    const parts = formatted.split(' ');
    parts[1] = parts[1].toUpperCase();
    return parts.join(' ');
  }


  const handleDownload = async (id, filename) => {
    try {
      const response = await axios.get(`${IMG_URL}/public/${id}`, {
        responseType: 'blob',
      });

      const contentType = response.headers['content-type'];

      let ext = '';
      if (contentType === 'image/jpeg') ext = 'jpg';
      else if (contentType === 'image/png') ext = 'png';
      else if (contentType === 'application/pdf') ext = 'pdf';

      const finalName = filename.includes('.') 
        ? filename 
        : `${filename}.${ext}`;

      fileDownload(response.data, finalName);

    } catch (error) {
      alert('Failed to download file');
      console.error(error);
    }
  };



    useEffect(() => {
  const fetchDynamicContent = async () => {
    try {
      const response = await axios.get(`${END_URL}dynamic-page`);
      setDynamicContent(response.data.data); // Assuming your API returns { data: ... }
    } catch (error) {
      console.error('Failed to fetch dynamic content:', error);
    }
  };

  fetchDynamicContent();
}, []);

const filteredPdfs = pdfs.filter((pdf) => {
  const matchesCategory = selectedCategory === '0' || pdf.category === selectedCategory;
  const matchesSearch = searchTerm === '' || 
    (pdf.filename && pdf.filename.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (pdf.description && pdf.description.toLowerCase().includes(searchTerm.toLowerCase()));
  return matchesCategory && matchesSearch;
});


  return (
    <div className="dashboard-container full-width">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="resource-wrapp">
                <div className="dashbord-first">
                  <div dangerouslySetInnerHTML={{ __html: dynamicContent?.resource1 }} />
                </div>

                <div className="filter-cate">
                  <div className="form-group">
                <input
  type="search"
  className="form-control"
  placeholder="Search resources..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>

                  </div>
                  <div className="form-group">
                   <select
                      className="form-control"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                      <option value="0">All Categories</option>
                      {categories.map((cat, idx) => (
                        <option key={idx} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>

                <div className="resource-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Resource</th>
                        <th>Category</th>
                        <th>Date Added</th>
                        <th>Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                  <tbody>
  {filteredPdfs.length === 0 ? (
    <tr>
  <td colSpan={5} style={{ textAlign: "center", padding: "50px 10px", minHeight:"200px", color: "#666" }}>
    <h4>No Resources Found.</h4>
    <p>No resources match your current search or filter criteria.</p>
  </td>
</tr>

  ) : (
    filteredPdfs.map((pdf) => (
      <tr key={pdf.id}>
        <td>
          <h4>{pdf.filename || pdf.urlname || "Untitled"}</h4>
          <p>{pdf.description || "No description available."}</p>
        </td>
        <td>{pdf.category || "Uncategorized"}</td>
        <td>{formatDate(pdf.created_at)}</td>
        <td>
     <span className={
  pdf.type === "pdf" ? "pdf" :
  pdf.type === "guide" ? "guide" : "link"
}>
  {pdf.type === "pdf"
    ? "Pdf"
    : pdf.type === "guide"
    ? "Guide"
    : "Link"}
</span>

        </td>
        <td>
         {(pdf.type === "pdf" || pdf.type === "guide") && pdf.pdfname ? (
  <button
    className="res-btn1"
    onClick={() => handleDownload(pdf.pdfname, pdf.filename)}
  >
    Download
  </button>
) : pdf.type === "link" && pdf.url ? (
  <a
    href={pdf.url}
    className="res-btn1"
    target="_blank"
    rel="noopener noreferrer"
  >
    Read More
  </a>
) : (
  <button className="res-btn1" disabled>
    N/A
  </button>
)}

        </td>
      </tr>
    ))
  )}
</tbody>


                  </table>
                </div>

               
              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResourceWrapp;
